
import { FDStat, FDTextInput } from '@facet-wealth/design';
import ChangeHistoryText
  from 'Views/Page/Content/Modal/Layouts/ManagedAccountModelUpdateRequestDialog/Layout/ChangeHistoryText';
import { SelectInputSmall } from 'Packages/FacetDesign/Components/SelectInput';
import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import { Richtext } from 'Packages/FacetDesign/Components/Richtext';
import CopyToClipboardStat
  from 'Views/Page/Content/Modal/Layouts/ManagedAccountModelUpdateRequestDialog/Layout/CopyToClipboardStat';
import { ManagedAccountModelUpdateOpenCaseCard } from './ManagedAccountModelUpdateOpenCaseCard';

const ManagedAccountModelUpdateRequestOverride = buildFacetDesignOverride()
  .nameOverride(['isComplete', 'assignedToRole'], { hidden: true })
  .nameOverride('openTIOCaseCard', {
    _component: () => ManagedAccountModelUpdateOpenCaseCard,
  }, overrideReadOnly)
  .nameOverride([
    'lastRiskToleranceChange',
    'lastObjectiveChange',
    'lastTimeHorizonChange',
  ], {
    _component: () => ChangeHistoryText,
  }, {
    ordinal: 300,
  })
  .typeOverride('picklist', {
    _component: () => SelectInputSmall,
    _customProps: {
      size: 'sm',
    },
  })
  .nameOverride('accountNumber', {
    _component: () => CopyToClipboardStat,
  }, {
    ordinal: 300,
  })
  .override(
    { readonly: true },
    {
      _component: () => FDStat,
    },
    {
      ordinal: 200,
    },
  )
  .override({ hint: 'richtext' },
    {
      _component: () => Richtext,
    },
    {
      ordinal: 300,
    })
  .override({ hint: 'multiline' },
    {
      _component: () => FDTextInput,
      _customProps: {
        rows: 3,
      },
    });

export default ManagedAccountModelUpdateRequestOverride;
